module.exports = __webpack_public_path__ + "static/media/resourceMastHead.03a5d2e0.webp";